import "./styles/Toast.css";

const Toast = ({ children }) => {
  return <div className="toast-component">{children}</div>;
};

export default Toast;
